import styled from 'styled-components';
import { default as UiLayout } from '@devdept/samolet-ui/lib/features/Layout/Layout';

export const Layout = styled(UiLayout)``;
